/**
 * Report a click through event. A click through event is when a user
 * clicks on a result link.
 *
 * @param documentId String The document ID associated with result that was
 * clicked
 * @param tag Array[String] Optional Tags which can be used to categorize
 * this click event
 */
export default function trackClickThrough(documentId) {
  var _console;

  var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (this.debug) // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, ["Search UI: Action", "trackClickThrough"].concat(Array.prototype.slice.call(arguments)));
  var _this$state = this.state,
      requestId = _this$state.requestId,
      searchTerm = _this$state.searchTerm;
  this.events.resultClick({
    query: searchTerm,
    documentId: documentId,
    requestId: requestId,
    tags: tags
  });
}